import L from "leaflet";
import {
  LocationIcon,
  DefaultIcon,
  NormFMSB,
  NormFM,
  NormSB,
  EmergencyIcon,
  EmerFMSB,
  EmerFM,
  EmerSB,
} from "../../../assets/icons";

export const Marker = (type, ticketAttachments) => {
  return L.icon(markerValidation(type, ticketAttachments));
};

const markerValidation = (type, ticketAttachments) => {
  switch (type) {
    case "TICKET":
      return {
        iconUrl: TicketIconValidation(ticketAttachments),
        iconSize: [32, 48],
        iconAnchor: [16, 48],
        className: "custom-img-icon",
        popupAnchor: [-6, -48],
      };
    case "LOCATION":
      return {
        iconUrl: LocationIcon,
        iconSize: [38, 38],
        iconAnchor: [19, 38],
        className: "custom-img-icon",
        popupAnchor: [0, -38],
      };
    case "PERFORMANCE":
      return {
        iconUrl: LocationIcon,
        iconSize: [32, 48],
        iconAnchor: [16, 48],
        className: "custom-img-icon",
        popupAnchor: [-6, -48],
      };
    default:
      return {
        iconUrl: TicketIconValidation(ticketAttachments),
        iconSize: [32, 48],
        iconAnchor: [16, 48],
        className: "custom-img-icon",
        popupAnchor: [-6, -48],
      };
  }
};

const TicketIconValidation = (ticketAttachments) => {
  const { priority, fmCheck, sbCheck } = ticketAttachments;
  let validatedIcon = DefaultIcon;

  if (priority === "EMER") {
    if (fmCheck && sbCheck) {
      validatedIcon = EmerFMSB;
    } else if (fmCheck) {
      validatedIcon = EmerFM;
    } else if (sbCheck) {
      validatedIcon = EmerSB;
    } else {
      validatedIcon = EmergencyIcon;
    }
  } else {
    if (fmCheck && sbCheck) {
      validatedIcon = NormFMSB;
    } else if (fmCheck) {
      validatedIcon = NormFM;
    } else if (sbCheck) {
      validatedIcon = NormSB;
    } else {
      validatedIcon = DefaultIcon;
    }
  }
  return validatedIcon;
};
